import _ from 'lodash';
import React, { memo } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  orderType: PropTypes.string,
  isBacktest: PropTypes.bool
};
const defaultProps = {
  orderType: '',
  isBacktest: false
};

const OrderTypeBadge = ({ orderType, isBacktest }) => {
  const type = _.capitalize(orderType);
  const badgeClasses = {
    Automatic: 'badge badge-dark',
    Backtest: 'badge badge-secondary',
    Historic: 'badge badge-secondary',
    Paper: 'badge badge-info',
  };

  const badgeClass = isBacktest
    ? 'badge badge-secondary'
    : badgeClasses[type] || 'badge badge-light';

  return (
    <span className={badgeClass}>{isBacktest ? 'Backtest' : type}</span>
  );
};

OrderTypeBadge.propTypes = propTypes;
OrderTypeBadge.defaultProps = defaultProps;

export default memo(OrderTypeBadge);
